const o = {
  id: "MinnesotaNorth5",
  logo: !0,
  name: "North 5",
  style: {
    colorPrimary: "#0eb0cc"
  }
};
export {
  o as default
};
